import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Media from 'react-media';
import { connect } from 'react-redux';
import moment from 'moment';

import classes from "./Tuple.scss";

import AnimakitExpander from "animakit-expander";
import cheapestFlightImage from '../../../assets/images/cheapest.svg';

import TupleInner from "./TupleInner/TupleInner";
import AirlineLogo from '../Airline/AirlineLogo/AirlineLogo';
import AirlineCode from '../Airline/AirlineCode/AirlineCode';
import AirlinePrice from '../Airline/AirlinePrice/AirlinePrice';
import Tooltip from '../../UI/Tooltip/Tootip';

// Airline
import AirlineWrapper from '../Wrappers/AirlineWrapper/AirlineWrapper';
import AirlineName from '../Airline/AirlineName/AirlineName';

// Stopover
import StopoverWrapper from '../Wrappers/StopoverWrapper/StopoverWrapper';
import AirlineStopover from '../Airline/AirlineStopover/AirlineStopover';

// Duration
import DurationWrapper from '../Wrappers/DurationWrapper/DurationWrapper';
import AirlineDuration from '../Airline/AirlineDuration/AirlineDuration';

// Timing
import TimingWrapper from '../Wrappers/TimingWrapper/TimingWrapper';
import AirlineTiming from '../Airline/AirlineTiming/AirlineTiming';

import Button from '../../UI/Button/Button';

import { arrivalDuration } from '../../../utility';

import * as fareRuleActions from '../../../store/actions/index';
import * as stackFlightActions from '../../../store/actions/index';
import * as farePriceActions from '../../../store/actions/index';
import * as flightActions from '../../../store/actions/index';

import ContainerPrimary from '../UI/Mobile/Tuple/ContainerPrimary/ContainerPrimary';
import ContainerSecondary from '../UI/Mobile/Tuple/ContainerSecondary/ContainerSecondary';
import ContainerSecondaryLeft from '../UI/Mobile/Tuple/ContainerSecondaryLeft/ContainerSecondaryLeft';
import ContainerSecondaryRight from '../UI/Mobile/Tuple/ContainerSecondaryRight/ContainerSecondaryRight';
import MobileTupleDivider from '../UI/Mobile/Tuple/TupleDivider/TupleDivider';
import MobileTimings from '../UI/Mobile/Tuple/Timings/Timings';
import MobileDuration from '../UI/Mobile/Tuple/Duration/Duration';
import AgencySummary from '../AgencySummary/AgencySummary';

import BoxCheapest from '../UI/Desktop/Tuple/BoxCheapest/BoxCheapest';
import BoxSeat from '../UI/Desktop/Tuple/BoxSeat/BoxSeat';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Deal from '../../UI/Deal/Deal';

class Tuple extends Component {
  rules = null;
  baggage = null;
  rulesCounter = null;
  baggageCounter = null;
  onwardTripFlightSchedule = null;
  onwardTripFareDetails = null;
  onwardTripDate = null;
  onwardTripSupplierCode = null;
  onwardTripFlightId = null;
  
  state = {
    tabIndex: 1,
    isTupleExpanded: false,
    isAgencyFareSummaryVisible: false,
    isHff: false
  };

  openAgencyFareSummaryVisible = () => this.setState({ isAgencyFareSummaryVisible: true })
  closeAgencyFareSummaryVisible = () => this.setState({ isAgencyFareSummaryVisible: false })

  switchTabHandler = (tabIndex) => {
    if (tabIndex === 2) {
        if (this.props.isIntFlight) {
          const fareRules = this.props.fareRules;
          
          let match = false;
          fareRules.forEach((element) => {
            if (element.id === this.props.flightId) {
              match = true;
              this.rules = element.rules;
            }
          })
          if (!match) {
            const fareRuleParams = { 
              sc: this.props.xmlKey, 
              flightIdCSV: this.props.flightId, 
              searchId: this.props.searchId 
            }
            this.rulesCounter = this.props.rulesCounter;
            this.props.onGetIntFareRules(fareRuleParams, this.props.flightId);
          }
        } else {
          const fareRules = this.props.fareRules;

          let match = false;
          fareRules.forEach((element) => {
            if (element.id === this.props.flightId) {
              match = true;
              this.rules = element.rules;
            }
          })
          if (!match) {
            const fareRuleParams =  {
              flightIdCSV: this.props.flightId,
              supplierCode: this.props.supplierCode,
              searchId: this.props.searchId,
              fareBasisCode: this.props.flightSchedule[0].FS[0].fbc,
              AirlineCode: this.props.flightSchedule[0].FS[0].ac,
              resBookDesigCode: this.props.flightSchedule[0].FS[0].resBookDesigCode,
              cabin: this.props.flightSchedule[0].FS[0].classtype
            }
            this.rulesCounter = this.props.rulesCounter;
            this.props.onGetFareRules(fareRuleParams, this.props.flightId);
          }
        }
    } else if(tabIndex === 3) {
      if (this.props.isIntFlight) {
        const intBaggage = this.props.intBaggage;
        let baggageMatch = false;
        intBaggage.forEach(element => {
          if (element.id === this.props.flightId) {
            baggageMatch = true;
            this.baggage = element.baggageData;
          }
        })
        if (!baggageMatch) {
          const baggageParams = {
            searchId: this.props.searchId,
            flightIdCSV: this.props.flightId,
            sc: this.props.xmlKey
          }
          this.baggageCounter = this.props.baggageCounter;
          this.props.onGetBaggageInfo(baggageParams, this.props.flightId);
        }
      }
    }
    
    const newTabIndex = tabIndex;
    this.setState(state => {
      if (state.tabIndex === newTabIndex) {
        return null;
      } else {
        return { tabIndex }
      }
    })
  }

  pricingHandler = (e) => {
    e.stopPropagation();
    // e.preventDefault();
    this.setState(prevState => {
      return { isTupleExpanded: !prevState.isTupleExpanded }
    });
  };

  proceedToBook = e => {
    e.stopPropagation();
    this.props.onClearPax();
    this.props.onResetFilters();
    this.props.onSetStackFlight(this.props.flightSchedule, this.props.fareDetails, this.props.date, this.props.supplierCode, this.props.flightId, "onward", this.props.xmlKey);

    let flightIdCSV = null;
    let flightCode = null;
    let supplierCode = null;

    const flightTotalPrice = Math.round(parseFloat(this.props.fareDetails.revisedFareDetails.af, 10));
    flightIdCSV = this.props.flightId;
    flightCode = this.props.flightCode;
    supplierCode = this.props.xmlKey;
    

    const queryParams = [];
    queryParams.push('searchId=' + this.props.searchId);
    queryParams.push('msid=' + this.props.searchId);
    queryParams.push('flightIdCSV=' + flightIdCSV);
    queryParams.push('flightPrice=' + flightTotalPrice);
    queryParams.push('sc=' + supplierCode);
    queryParams.push('flightCode=' + flightCode);
    queryParams.push('isInt=' + this.props.isIntFlight);
    queryParams.push('isHff=' + this.state.isHff);

    const queryString = queryParams.join("&");

    this.props.history.push({
      pathname: "/reviews/details",
      search: "?" + queryString
    });
  };

  toggleHffHandler = (e) => {
    e.stopPropagation();
    this.setState(prevState => {
      return {
        isHff: !prevState.isHff
      }
    })
  }


  render() {
    this.count += 1;
    const FS = this.props.flightSchedule[0].FS;
    const airlineCode = this.props.flightSchedule[0].FS[0].ac;
    const OD = this.props.flightSchedule[0];
    const TF = this.props.fareDetails.revisedFareDetails.tf;
    let arrivalDate = null;
    // Check of arrival and departure dates
    if(!moment(FS[0].ddt).isSame(FS[FS.length - 1].adt)) {
      arrivalDate = moment(FS[FS.length - 1].adt).format("DD MMM");
    }

    if (this.props.rulesCounter > this.rulesCounter) {
      this.props.fareRules.forEach((element) => {
        if (element.id === this.props.flightId) {
          this.rules = element.rules;
        }
      });
    }

    if (this.props.baggageCounter > this.baggageCounter) {
      this.props.intBaggage.forEach(element => {
        if (element.id === this.props.flightId) {
          this.baggage = element.baggageData;
        }
      })
    }

    const border = '1px solid var(--color-border)';
    const borderDashed = '1px dashed var(--color-border)';

    return (
      <div className={`u-borderBottomNormal`}
        style={{
          borderBottom: window.innerWidth > 600 ? this.props.clubbed ? `${border}` : '1px solid transparent' : this.props.clubbed ? '1px solid #e4e4e4' : '1px solid transparent'
        }}>
        <Media query="(max-width: 599px)">
          {matches => 
            matches ? (
              <div onClick={this.pricingHandler}
                   className={classes.TupleContainer}
                   style={{ borderBottom: this.state.isTupleExpanded ? `${borderDashed}` : '1px solid transparent' }}>
                  <ContainerPrimary>
                    <AirlineLogo airlineCode={airlineCode} />
                  </ContainerPrimary>
                  <ContainerSecondary>
                    <ContainerSecondaryLeft>
                      <div style={{width: '100%', lineHeight: '1', marginBottom: '1rem'}} className={`u-flex justify-content-between`}>
                        <MobileTimings>
                          <span>{FS[0].dd}</span>
                          <MobileTupleDivider/>
                          <span>{FS.length === 1 ? FS[0].ad : FS[FS.length - 1].ad}</span>
                        </MobileTimings>
                        <AirlinePrice 
                          onClick={this.proceedToBook} 
                          index={this.props.index}
                          tf={TF} />
                        {this.props.showAgentProfit ? <p className={`u-absolute u-top35Percent u-right5Percent`}><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.commision).toLocaleString()}</span><span className={`mr-1 ml-1 mt-1`}>|</span><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.nf).toLocaleString()}</span></p> : null}
                      </div>
                      <div style={{width: '56.88%'}} className={`u-flex justify-content-between`}>
                        <MobileDuration>
                          <span>{OD.tdu.substring(0, 2) + "h " + OD.tdu.substring(3, 5) + "m"}</span>
                        </MobileDuration>
                        <StopoverWrapper>
                          <AirlineStopover cityNames={this.props.cityNames} OD={OD} FS={FS} />
                        </StopoverWrapper>
                      </div>
                    </ContainerSecondaryLeft>
                    <ContainerSecondaryRight>
                      <p className={classes.AirlineDetail}>
                        <AirlineName FS={FS} airlineNames={this.props.airlineNames} />
                        <span>&nbsp;&nbsp;</span>
                        <AirlineCode FS={FS} />
                        {
                          this.props.fareDetails.revisedFareDetails.description !== '' ? <div className={`u-flex u-absolute align-items-center u-lineHeight1 u-bottom4 u-absolute u-left0 u-right0 pl-4`}><div className={`u-flex align-items-center mr-1 u-fontSize11 u-lineHeight1 u-textColorLight`}><div className={`mr-1`}><Deal/></div>{this.props.fareDetails.revisedFareDetails.description}</div></div> : null
                        }
                      </p>
                      <span className={`u-phoneShow u-block u-fontSize11 u-textUppercase u-fontWeightRegular u-textColorDark`}>Details<span className={`u-inlineBlock u-transition--transform200Spring ml-1`} style={{transform: this.state.isTupleExpanded ? 'rotate(-180deg)' : 'rotate(0deg)'}}><FontAwesomeIcon icon="angle-down" color="#666" size="lg" /></span></span>
                    </ContainerSecondaryRight>
                  </ContainerSecondary>
              </div>
            ) : (
              <div onClick={this.pricingHandler}
          className={classes.TupleContainer}
          style={{ borderBottom: this.state.isTupleExpanded ? `${borderDashed}` : '1px solid transparent' }}>
          <div className={classes.TupleContainerPrimary}>
            <AirlineWrapper>
              <AirlineLogo airlineCode={airlineCode} />
                  <p className={classes.AirlineDetail}>
                    <AirlineName FS={FS} airlineNames={this.props.airlineNames} />
                    <AirlineCode FS={FS} />
                  </p>
                  {
                    this.props.fareDetails.revisedFareDetails.description !== '' ? <div className={`u-flex u-absolute align-items-center u-lineHeight1 u-bottom4`}><div className={`u-flex align-items-center mr-1 u-fontSize11 u-lineHeight1 u-textColorLight`}><div className={`mr-1`}><Deal/></div>{this.props.fareDetails.revisedFareDetails.description}</div></div> : null
                  }
            </AirlineWrapper>
            <TimingWrapper>
              <AirlineTiming>{FS[0].dd}</AirlineTiming>
              <span className={classes.Line}></span>
              <AirlineTiming>{arrivalDuration(this.props.flightSchedule)} {arrivalDate !== null ? <span className={`${classes.ArrivalDate} u-textColorRed`}>{arrivalDate}</span> : null}</AirlineTiming>
            </TimingWrapper>
            <DurationWrapper>
              <AirlineDuration OD={OD} />
            </DurationWrapper>
            <StopoverWrapper>
              <AirlineStopover cityNames={this.props.cityNames} OD={OD} FS={FS} />
            </StopoverWrapper>
          </div>
          <div className={classes.TupleContainerSecondary}>
            <div className={classes.Box1}>
              {this.props.index === 0 ?
                <React.Fragment>
                  {FS[0].sl === '' || !FS[0].sl || parseInt(FS[0].sl, 10) >= 9 ? null : 
                <BoxSeat>{FS[0].sl}</BoxSeat>}  
                  <BoxCheapest>
                      <Tooltip type="stopCity" aria-label="Cheapest"><img src={cheapestFlightImage} alt="Cheapest Flight" /></Tooltip>
                  </BoxCheapest>
                </React.Fragment> : FS[0].sl === '' || !FS[0].sl || parseInt(FS[0].sl, 10) >= 9 ? null : 
                <BoxSeat>{FS[0].sl}</BoxSeat>
              }
              <div className={classes.Box1Extended}>
                <div className={classes.Price}>
                  {this.state.isAgencyFareSummaryVisible ? <AgencySummary fareDetails={this.props.fareDetails}/> : null}
                  <Media query="(max-width: 599px)">
                    {matches =>
                      matches ? 
                      <AirlinePrice 
                        onMouseEnter={() => this.openAgencyFareSummaryVisible()} 
                        onMouseLeave={() => this.closeAgencyFareSummaryVisible()}
                        onClick={this.proceedToBook}
                        index={this.props.index}
                        tf={TF} /> :
                      <AirlinePrice 
                        onMouseEnter={() => this.openAgencyFareSummaryVisible()} 
                        onMouseLeave={() => this.closeAgencyFareSummaryVisible()}
                        index={this.props.index} 
                        tf={TF} />}
                  </Media>
                  {this.props.showAgentProfit ? <p><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.commision).toLocaleString()}</span><span className={`mr-1 ml-1 mt-1`}>|</span><span>&#8377;{Math.round(this.props.fareDetails.revisedFareDetails.nf).toLocaleString()}</span></p> : null}
                </div>
              </div>
            </div>
            <div className={classes.Box2}>
              <Button theme='Primary' type='BookSmall' onClick={this.proceedToBook}>{this.state.isHff ? 'Hold' : 'Book'}</Button>
              <div style={{
                transform: this.state.isTupleExpanded ? 'rotate(-180deg)' : 'rotate(0deg)',
                transition: 'all .3s ease'
              }}
              onClick={this.pricingHandler}
              className={`u-cursorPointer u-phoneHide ml-3`}>
                <FontAwesomeIcon icon="angle-down" color="#666" size="lg" />
              </div>
            </div>
          </div>
          {OD.hff ? JSON.parse(OD.hff) ? <input type="checkbox" checked={this.state.isHff} onChange={(e) => this.toggleHffHandler(e)} /> : null : null}
        </div>
            )}
        </Media>      
          <AnimakitExpander
            expanded={this.state.isTupleExpanded}
            duration={400}
            align="top"
          >
            <TupleInner
              flightSchedule={this.props.flightSchedule}
              fareDetails={this.props.fareDetails}
              fareRules={this.rules}
              intBaggage={this.baggage}
              clubbed={this.props.clubbed}
              switchTab={this.switchTabHandler}
              tabIndex={this.state.tabIndex}
              proceedToBookHandler={this.proceedToBook}
              stackHandler={this.showReturnFlightsHandler}
              cityName={this.props.cityName}
              cityNames={this.props.cityNames}
              airlineNames={this.props.airlineNames}
              airportNames={this.props.airportNames}
              isIntFlight={this.props.isIntFlight}
          />
          </AnimakitExpander>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cityName: state.flights.cityName,
    cityNames: state.flights.cityNames,
    airlineNames: state.flights.airlineNames,
    airportNames: state.flights.airportNames,
    flightCode: state.flights.flightCode,
    flightCodeRound: state.flights.flightCodeRound,
    searchId: state.flights.searchId,
    date: state.flights.departDate,
    fareRules: state.fareRules.fareRules,
    farePrice: state.farePrice.farePrice,
    intBaggage: state.fareRules.intBaggage,
    rulesCounter: state.fareRules.counter,
    baggageCounter: state.fareRules.baggageCounter,
    returnFlights: state.flights.returnFlights,
    isIntFlight: state.flights.requestParams.originCountry !== 'IN' || state.flights.requestParams.destinationCountry !== 'IN',
    showAgentProfit: state.ui.showAgentProfit
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onGetFareRules: (fareRuleParams, flightId) => dispatch(fareRuleActions.getFareRules(fareRuleParams, flightId)),
    onGetIntFareRules: (fareRuleParams, flightId) => dispatch(fareRuleActions.getIntFareRules(fareRuleParams, flightId)),
    onSetStackFlight: (flightSchedule, fareDetails, date, supplierCode, flightId, flightType, xmlKey) => dispatch(stackFlightActions.setStackFlight(flightSchedule, fareDetails, date, supplierCode, flightId, flightType, xmlKey)),
    onClearPax: () => dispatch(farePriceActions.clearPax()),
    onGetBaggageInfo: (baggageParams, flightId) => dispatch(fareRuleActions.getBaggageInfo(baggageParams, flightId)),
    onResetFilters: () => dispatch(flightActions.resetFilters())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Tuple));



// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/Tuple.js